export const ENTERPRISE_ADMIN_DETAILS = "ENTERPRISE_ADMIN_DETAILS";

const initialState = null;

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case ENTERPRISE_ADMIN_DETAILS:
            return action.payload;
        default:
            return state;
    }
}

const storeName = "enterpriseDetails";

const storeMapping = {[storeName]: reducer};

export const enterpriseDetailsSelector = (state) => state[storeName];

export default storeMapping;

